<script setup lang="ts">
import { RouterLink } from "vue-router";
import { ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { edit, drag, minus, upload } from "pn-design-assets/pn-assets/icons";
import { useImageStore } from "@/stores/images";

const imageStore = useImageStore();
const { categories: cats } = storeToRefs(imageStore);
const dragsource = ref("");
const dragtarget = ref("");
const refresh = async () => {
  await imageStore.getImageCategories();
};
onMounted(async () => {
  await refresh();
});
const dragenter = (e: any) => {
  e.preventDefault();
};
const dragover = (e: any) => {
  dragtarget.value = e.target.closest("tr").dataset.id;

  e.target.closest("tr").classList.add("target");
  e.preventDefault();
};
const dragleave = (e: any) => {
  e.target.closest("tr").classList.remove("target");
};
const dragstart = (e: any) => {
  dragsource.value = e.target.closest("tr").dataset.id;
};
const drop = async (e: any) => {
  e.target.closest("tr").classList.remove("target");
  const sourceIx = cats.value.findIndex(
    (c) => c.categoryId.toString() === dragsource.value,
  );
  const source = cats.value.splice(sourceIx, 1)[0];
  if (dragtarget.value === "last") {
    cats.value.push(source);
  } else {
    const targetIx = cats.value.findIndex(
      (c) => c.categoryId.toString() === dragtarget.value,
    );
    cats.value.splice(targetIx, 0, source);
  }

  dragsource.value = "";
  dragtarget.value = "";
  await imageStore.reorderImageCategories(cats.value.map((c) => c.categoryId));
};
</script>

<template>
  <h1>Categories</h1>
  <pn-table bordered="true" striped="true">
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Languages</th>
          <th>id</th>
          <th colspan="2">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="c in cats"
          :key="c.categoryId"
          :data-id="c.categoryId"
          draggable="true"
          @dragstart="dragstart"
          @drop="drop"
          @dragenter="dragenter"
          @dragleave="dragleave"
          @dragover="dragover"
        >
          <td>{{ c.swedish || c.english || c.danish || c.norwegian }}</td>
          <td class="flags">
            <span v-show="c.swedish"><img src="/se.svg" /></span>
            <span v-show="c.english"><img src="/gb.svg" /></span>
            <span v-show="c.danish"><img src="/dk.svg" /></span>
            <span v-show="c.norwegian"><img src="/no.svg" /></span>
          </td>
          <td>{{ c.categoryId }}</td>
          <td>
            <RouterLink
              class="pnbutton small icononly"
              :to="`/categories/${c.categoryId}`"
              ><pn-icon :icon="edit" color="blue700" small="true"
            /></RouterLink>
          </td>
          <td>
            <pn-icon :icon="drag" color="blue700">Drag</pn-icon>
          </td>
        </tr>
        <tr>
          <td
            data-id="last"
            style="text-align: center"
            colspan="3"
            @drop="drop"
            @dragenter="dragenter"
            @dragleave="dragleave"
            @dragover="dragover"
          >
            <pn-icon :symbol="minus" color="blue700" />
          </td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </pn-table>
  <p>
    <RouterLink class="pnbutton" :to="`/categories/new`">
      Add new category <pn-icon :symbol="upload" color="blue700" small="true" />
    </RouterLink>
  </p>
</template>

<style lang="scss" scoped>
.target {
  border-top: 3px dashed gray;
}

td > pn-icon {
  padding-bottom: 0.3rem;
}

.flags > span {
  margin-left: 5px;
}
.flags img {
  border: 0;
  border-radius: 0;
  width: 20px;
}

img {
  border: 1px dashed gray;
  border-radius: 1rem;
  width: 300px;
}
</style>
